<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>考勤初始化流程说明:</h5><br>
				<span>1、按部门建立考勤模板。</span><br>
				<span>2、按照模板生成每个部门的对应月份的出勤表。</span><br>
				<span>3、按照部门模板生成每个人的对应月份的出勤表,提交进行使用。</span><br>
				<span>3、按照部门模板生成每个人的对应月份的出勤表,提交进行使用。</span><br>
				<span>4、每个人按天打卡，生成流水记录，然后去修改他/她的 对应月份的出勤表。</span><br>
				<span>5、允许根据实际情况修正出勤记录。</span><br>
				<span>6、发起请假申请->审核通过 后修改对应 出勤记录。</span><br>
				<span>7、发起调休申请->审核通过 后修改对应 出勤记录。</span><br>
				<span>8、根据设定好的基本工资表。从相关业务单据中去取 扣款+奖励 等费用。</span><br>
				<span class="red">9、作废后不删除已经生成模板，然后修改日期，可以重新新建部门模板。</span><br>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">

			<!-- <template slot="slot_c_out_fee">
            <pre-select class="short0" ref="out_fee" @selectFunc="selectFunc1" v-bind:searchList="list_fee"
              :selectValue="sel_fee" />
          </template> -->

		</pre-base>
	</div>
</template>

<script>
	import api from '@/utils/type.js';
	import {
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';
	export default {
		components: {
			"pre-base": () => import("../per_old/pre_mode_tan.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',
				// 下拉菜单
				// list_fee: [],
				// sel_fee: {},
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: async function() {

				let
					t_list_flag = [],
					t_list_dep = [];

				t_list_flag = await this.loadClass('data_flag');

				t_list_dep = await this.loadClass('data_dep', '1');

				this.init_data = '';
				this.init_data = JSON.stringify({
					"title": '建立部门考勤模板',
					"control": "recorddepbuild",
					"action_flag":"",
					"sel_action": 'exp_kq_rec_mode',
					"upd_action": 'kq_rec_mode',
					"d_sel_action": '',
					"d_upd_action": '',
					"isTwo": "0",
					"step": "1",
					"file_action": 'rec_mode',
					"p1": 'bdwl',
					"p2": 'rec_mode',
					"p3": '',
					"parm_sel": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long2",
							"sel": "1"
						},
						{
							"name": "状态",
							"val": "",
							"key": "flag",
							"type": "select",
							"class": "long1",
							"list": t_list_flag.data,
							"sel_val": {},
							"sel_name": "",
							"sel": "2"
						}
					],
					"parm": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "readonly",
							"class": "long2",
							"p": "1",
							"x": "1"
						},
						{
							"name": "部门选择",
							"val": "",
							"key": "d_name",
							"type": "checkbox",
							"list": t_list_dep.data,
							"sel_name": "",
							"checked_list": [],
							"check_all": false,
							"class": "long1",
							"weight": "1",
							"p": "1",
							"x": "2"
						},
						{
							"name": "开始日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1",
							"weight": "1",
							"p": "1",
							"x": "3"
						},
						{
							"name": "结束日期",
							"val": "",
							"key": "e_date",
							"type": "date",
							"class": "long1",
							"weight": "1",
							"p": "1",
							"x": "3"
						},
						{
							"name": [{
								"id": "1",
								"name": "全部出勤",
								"val": "0"
							}, {
								"id": "2",
								"name": "周日休息",
								"val": "1"
							}, {
								"id": "3",
								"name": "周六周日休息",
								"val": "2"
							}],
							"val": "1",
							"key": "record_type",
							"type": "radio",
							"class": "long1",
							"weight": "1",
							"p": "1",
							"x": "3"
						},
						{
							"name": "上午上班时间",
							"val": new Date(2021, 8, 15, 9, 0),
							"key": "m_up_time",
							"type": "time",
							"class": "long1",
							"weight": "1",
							"p": "1",
							"x": "4"
						},
						{
							"name": "上午下班时间",
							"val": "",
							"key": "m_down_time",
							"type": "none",
							"class": "long1",
							"p": "1",
							"x": "4"
						},
						{
							"name": "下午上班时间",
							"val": "",
							"key": "a_up_time",
							"type": "none",
							"class": "long1",
							"p": "1",
							"x": "4"
						},
						{
							"name": "下午下班时间",
							"val": new Date(2021, 8, 15, 18, 0),
							"key": "a_down_time",
							"type": "time",
							"class": "long1",
							"weight": "1",
							"p": "1",
							"x": "4"
						},

						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"x": "5"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "申请单"
						},
						{
							"name": "部门"
						},
						{
							"name": "开始日期"
						},
						{
							"name": "结束日期"
						},
						{
							"name": "状态"
						},
						{
							"name": "出勤类型"
						},
						{
							"name": "上午上班时间"
						},
						// {
						//   "name": "上午下班时间"
						// },
						// {
						//   "name": "下午上班时间"
						// },
						{
							"name": "下午下班时间"
						},
						{
							"name": "备注"
						},
						{
							"name": "录入人"
						},
						{
							"name": "更新时间"
						}
					],
					"d_parm": [],
					"d_name": []
				});

			},
			refresh_data: function(type) {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data(type);
				});
			},
			refresh_children: function(type, id, val) {
				var that = this;
				if (type == 'slot_c_out_fee') {
					this.$nextTick(function() {
						that.$refs['mybase'].refesh_parm(type, id, val, 'children');
					});
				} else {
					this.$message({
						message: '类别=!' + type + ' 没有配置相关操作!',
						type: 'error'
					});
				}
			},
			refresh_father: function(type, val, parm) {
				// console.log('type=' + type + ' val=' + val);
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					case 'blank':
						// 清空下拉菜单选项 没有起作用
						console.log('清空下拉菜单');
						this.sel_depart = {};
						break;
						// case 'slot_c_out_fee':
						//   this.selectFunc1(val);
						//   if (val == 'clear') {
						//     this.$refs['out_fee'].clearselect();
						//   }
						//   break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			// selectFunc1: function(value) {
			//   // console.log('选择结果='+parm);
			//   for (var i = 0; i < this.list_fee.length; i++) {
			//     if (this.list_fee[i].id == value || this.list_fee[i].val == value) {
			//       this.refresh_children('slot_c_out_fee', this.list_fee[i].id, this.list_fee[i].val)
			//       break;
			//     }
			//   }
			// },
			loadClass: function(action, p1, p2, p3) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2, p3)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});

				});
			},





		}
	};
</script>
<style>
</style>